// Labels for the "outstanding details" codes a journey/booking can carry
// (originally crew jobs only; reduced-minimum-dataset bookings use the same
// codes). Keep in sync with CREW_JOB_OUTSTANDING_LABELS in
// server/src/helpers/PTS/crewJobs.js
export const OUTSTANDING_LABELS = {
  patient: "the patient's name",
  patientIdentifier: 'a date of birth, NHS number or hospital number',
  mobility: "the patient's mobility",
  destination: 'the destination',
}

// Short chip-friendly versions of the same codes
export const OUTSTANDING_CHIP_LABELS = {
  patient: 'Patient name',
  patientIdentifier: 'DOB / NHS / hospital number',
  mobility: 'Mobility category',
  destination: 'Destination',
}

export const describeOutstanding = (outstanding = []) =>
  outstanding
    .map((code) => OUTSTANDING_LABELS[code])
    .filter(Boolean)
    .join(', ')
